import { get } from 'lodash';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ProfileEditor, {
  DIVERSE_DIVERSE,
  DIVERSE_MAIN,
  MAIN_MAIN,
} from 'src/components/profilechart/ProfileEditorModal';

function PMPProfileChart({
  profile,
  ap,
  sm,
  local,
  remote,
  setModified,
  parentFormSubmitHandler,
  modified,
}) {
  const { getValues } = useFormContext();
  // we are setting the default value of component carrier to 1
  // which works wells now, but when we are going to support more than 2
  // carriers we need to look at sm state and set the default value
  const [selectedPath, setSelectedPath] = useState(MAIN_MAIN);

  const prefs = useSelector((state: any) => state.mainFrame.prefs);
  const [remoteHeight, componentCarrierQty] = getValues([
    'radios.0.antennas.0.height',
    'radio_qty',
  ]);
  const carrierQty = get(ap, 'radios.0.equipment.carrier_qty');

  const hasMultiplePaths = carrierQty > 1 && componentCarrierQty > 1;
  let selectedPathOptions = null;
  if (hasMultiplePaths) {
    selectedPathOptions = [
      { text: 'Component Carrier 1', key: MAIN_MAIN, value: MAIN_MAIN },
      {
        text: 'Component Carrier 2',
        key: DIVERSE_DIVERSE,
        value: DIVERSE_DIVERSE,
      },
    ];
  }
  if (componentCarrierQty > 2) {
    selectedPathOptions.push({
      text: 'Component Carrier 3',
      key: DIVERSE_MAIN,
      value: DIVERSE_MAIN,
    });
  }

  const profileProps = {
    accordionName: 'SubscriberPanelProfile',
    profileData: profile,
    localHeight: local.height,
    remoteHeight,
    sm,
    // Unlike on PTP, we don't have a path here (but we should).
    // Hack one in for now so that the profile works.
    path: {},
    frequencyGHz:
      get(ap, `radios.${selectedPath}.frequency.frequency_mhz`, 5800) / 1000,
    rangeUnits: prefs.rangeUnits,
    heightUnits: prefs.heightUnits,
    localSiteName: local.site_name,
    remoteSiteName: remote.site_name,
    //errMsg: profileData.errMsg,
    loading: false,
    kind: 'pmp',
    modified,
    setModified,
    parentFormSubmitHandler,
    selectedPath,
    setSelectedPath,
    selectedPathOptions,
  };
  return <ProfileEditor {...profileProps} />;
}

export default PMPProfileChart;
